<dx-popup
    #arAdjustmentEditorPopup
    width="80%"
    height="80%"
    [title]="popupTitle"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onShown()"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col" class="add-ar-adjustment-editor">
            <dxi-item baseSize="auto">
                <div *dxTemplate class="margin-bottom-5px">
                    <dx-form width="100%" height="100%" [colCount]="3" class="adjustment-editor-form">
                        <dxi-item [colSpan]="2">
                            <dxo-label text="Adjustment Type"></dxo-label>
                            <div *dxTemplate>
                                <dx-select-box
                                    displayExpr="displayText"
                                    valueExpr="key"
                                    [width]="110"
                                    [dataSource]="adjustmentTypes"
                                    [(value)]="adjustmentInfo.adjustmentTypeCode"
                                    [readOnly]="!arAdjustmentEditor.allowFullEdit"
                                ></dx-select-box>
                            </div>
                        </dxi-item>

                        <dxi-item>
                            <div class="history-icon" *dxTemplate>
                                <dx-toolbar>
                                    <dxi-item location="after">
                                        <div *dxTemplate>
                                            <app-attachment-editor
                                                [viewOnly]="!arAdjustmentEditor.allowFullEdit"
                                                [communityId]="arAdjustmentParam.communityId"
                                                [attachments]="arAdjustmentAttachments"
                                                (onAttachmentUpdate)="onAttachmentUpdate($event)"
                                            ></app-attachment-editor>
                                        </div>
                                    </dxi-item>

                                    <dxi-item location="after" *ngIf="isEdited && isInternalUser">
                                        <div *dxTemplate>
                                            <dx-button
                                                [icon]="iconHistory"
                                                hint="Transaction History"
                                                (onClick)="onTransactionLogClick()"
                                            ></dx-button>
                                        </div>
                                    </dxi-item>
                                </dx-toolbar>
                            </div>
                        </dxi-item>

                        <dxi-item [colSpan]="3">
                            <dxo-label text="Description"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-box [(value)]="adjustmentInfo.description"></dx-text-box>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Document Date"></dxo-label>
                            <div *dxTemplate>
                                <dx-date-box
                                    type="date"
                                    [openOnFieldClick]="true"
                                    [showClearButton]="true"
                                    [(value)]="adjustmentInfo.docDate"
                                ></dx-date-box>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Post Date"></dxo-label>
                            <div *dxTemplate>
                                <dx-date-box
                                    type="date"
                                    [readOnly]="!arAdjustmentEditor.allowFullEdit"
                                    [openOnFieldClick]="true"
                                    [showClearButton]="true"
                                    [(value)]="adjustmentInfo.postDate"
                                ></dx-date-box>
                            </div>
                        </dxi-item>
                        <dxi-item isRequired="true">
                            <dxo-label text="Sub Ledger"></dxo-label>
                            <div *dxTemplate>
                                <dx-select-box
                                    displayExpr="displayText"
                                    valueExpr="key"
                                    [readOnly]="!arAdjustmentEditor.allowFullEdit"
                                    [dataSource]="subLedgers"
                                    [(value)]="adjustmentInfo.subLedgerId"
                                    (onValueChanged)="onSubLedgerChanged($event)"
                                ></dx-select-box>
                            </div>
                        </dxi-item>

                        <dxi-item [colSpan]="1" *ngIf="isEdited">
                            <dxo-label text="Charge"></dxo-label>
                            <div *dxTemplate>
                                {{ arAdjustmentEditor?.charge | ccCurrency }}
                            </div>
                        </dxi-item>
                        <dxi-item [colSpan]="1" *ngIf="isEdited">
                            <dxo-label text="Charge Due"></dxo-label>
                            <div *dxTemplate>
                                <span *ngIf="!adjustmentDetail?.allowCreditApplications">
                                    {{ arAdjustmentEditor?.chargeDue | ccCurrency }}
                                </span>

                                <div *ngIf="adjustmentDetail?.allowCreditApplications">
                                    <app-hyperlink-creator
                                        [displayText]="arAdjustmentEditor?.chargeDue | ccCurrency"
                                        (onLinkClick)="showARManualCreditApplication()"
                                    ></app-hyperlink-creator>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item [colSpan]="1" *ngIf="isEdited">
                            <dxo-label text="Last Updated by"></dxo-label>
                            <div *dxTemplate>
                                {{ arAdjustmentEditor?.updatedBy?.displayName }}
                            </div>
                        </dxi-item>
                        <dxi-item [colSpan]="3">
                            <dxo-label text="Customer Name"></dxo-label>
                            <div *dxTemplate>
                                {{ arAdjustmentEditor?.customerName }}
                            </div>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto" *ngIf="isInternalUser">
                <div *dxTemplate class="margin-bottom-5px">
                    <dx-toolbar>
                        <dxi-item
                            location="after"
                            widget="dxButton"
                            [options]="{
                                type: 'default',
                                template: 'multiIconTemplate',
                                text: addLineItemButtonOptions,
                                onClick: onNewLineItemClick
                            }"
                        ></dxi-item>
                        <app-multi-icon-button-template>
                            <app-security-info
                                iconColor="cc-white-icon"
                                securityIndicator="KEY"
                                apiAction="POST"
                                [apiUrl]="apiUrl"
                            ></app-security-info>
                        </app-multi-icon-button-template>
                    </dx-toolbar>
                </div>
            </dxi-item>

            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-data-grid
                        #arAdjustmentEditorGrid
                        ccAddNewRow
                        *ngIf="!!adjustmentInfo"
                        height="95%"
                        keyExpr="sequenceItemId"
                        class="cc-vertical-center-cell-data-grid"
                        [highlightChanges]="true"
                        [repaintChangesOnly]="true"
                        [dataSource]="adjustmentInfo.items"
                        [allowColumnReordering]="true"
                        [allowColumnResizing]="true"
                        [columnAutoWidth]="true"
                        [showBorders]="true"
                        [showColumnLines]="true"
                        [showRowLines]="true"
                        (onRowUpdated)="onRowUpdated($event)"
                        (onContentReady)="onEditorContentReady($event)"
                        (onAddNewRow)="onNewLineItemClick()"
                    >
                        <dxo-editing
                            mode="cell"
                            selectTextOnEditStart="true"
                            allowUpdating="true"
                            [useIcons]="true"
                        ></dxo-editing>
                        <dxo-pager [visible]="false"></dxo-pager>
                        <dxo-paging [enabled]="false"></dxo-paging>

                        <dxo-load-panel [enabled]="false"></dxo-load-panel>

                        <dxi-column
                            *ngIf="isInternalUser"
                            caption="Action"
                            alignment="center"
                            cellTemplate="deleteCellTemplate"
                            headerCellTemplate="actionHeaderCellTemplate"
                            width="70"
                        ></dxi-column>

                        <dxi-column
                            dataType="number"
                            caption="Item #"
                            width="70"
                            cellTemplate="itemNumber"
                        ></dxi-column>

                        <dxi-column
                            caption="Account"
                            dataField="selectedAccountName"
                            dataType="string"
                            width="220"
                            headerCellTemplate="mandatoryCellTemplate"
                            editCellTemplate="accountEditCellTemplate"
                            [showEditorAlways]="arAdjustmentEditor?.allowFullEdit"
                            [allowEditing]="arAdjustmentEditor?.allowFullEdit"
                        ></dxi-column>

                        <ng-container *ngIf="arAdjustmentEditor?.entityUsesSubCategory">
                            <dxi-column
                                dataField="subCategory"
                                dataType="string"
                                caption="Sub Category"
                                width="200"
                                [allowSorting]="false"
                                editCellTemplate="subCategoryTemplate"
                                [showEditorAlways]="true"
                                [allowEditing]="true"
                            ></dxi-column>
                        </ng-container>

                        <dxi-column
                            dataField="amount"
                            dataType="number"
                            caption="Amount"
                            width="110"
                            headerCellTemplate="mandatoryCellTemplate"
                            [format]="currencyFormat"
                            [showEditorAlways]="arAdjustmentEditor?.allowFullEdit"
                            [allowEditing]="arAdjustmentEditor?.allowFullEdit"
                            [editorOptions]="{ format: currencyFormat }"
                        ></dxi-column>

                        <dxi-column
                            dataField="openBalance"
                            dataType="number"
                            width="130"
                            caption="Open Balance"
                            [format]="currencyFormat"
                            [allowEditing]="false"
                            [editorOptions]="{ format: currencyFormat }"
                        ></dxi-column>

                        <ng-container *ngIf="dimensionSource.length > 0">
                            <!-- 
                                Note: This property is used only in edit mode. true - allow other dimension for edit
                                This property is not dependent on the AllowFullEdit property. ie it is always editable if AllowOtherDimensionEdit is true 
                                Change by Saad : 02-09-2023 : Now adding condition of limited edit also for board member user
                            -->
                            <ng-container *ngFor="let col of dimensionSource">
                                <dxi-column
                                    width="180"
                                    dataType="string"
                                    [dataField]="col.code"
                                    [caption]="col"
                                    headerCellTemplate="requiredDimensionColumnHeaderTemplate"
                                    [allowSorting]="false"
                                    [showEditorAlways]="col.isEditable"
                                    [allowEditing]="col.isEditable"
                                    [editorOptions]="{ placeholder: '' }"
                                >
                                    <dxo-lookup
                                        [dataSource]="col.options"
                                        displayExpr="text"
                                        valueExpr="code"
                                        [allowClearing]="col.isEditable"
                                    ></dxo-lookup>
                                </dxi-column>
                            </ng-container>
                        </ng-container>

                        <dxi-column
                            dataField="description"
                            dataType="string"
                            caption="Description"
                            [showEditorAlways]="true"
                            [allowEditing]="true"
                            [editorOptions]="{ showClearButton: true }"
                        ></dxi-column>

                        <div *dxTemplate="let header of 'actionHeaderCellTemplate'">
                            {{ header.column.caption }}
                            <app-security-info
                                securityIndicator="KEY"
                                apiAction="PUT"
                                [apiUrl]="apiUrl"
                            ></app-security-info>
                        </div>

                        <div *dxTemplate="let d of 'deleteCellTemplate'">
                            <dx-button
                                type="danger"
                                stylingMode="text"
                                [icon]="iconDelete"
                                (onClick)="onDeleteFromGrid(d.data)"
                            ></dx-button>
                        </div>

                        <div *dxTemplate="let header of 'mandatoryCellTemplate'">
                            {{ header.column.caption }}
                            <sup class="cc-text-required">*</sup>
                        </div>

                        <div *dxTemplate="let header of 'requiredDimensionColumnHeaderTemplate'">
                            {{ header.column.caption.text }}
                            <sup *ngIf="header.column.caption.required" class="cc-text-required">*</sup>
                        </div>

                        <div *dxTemplate="let cellInfo of 'subCategoryTemplate'">
                            <dx-select-box
                                displayExpr="title"
                                valueExpr="code"
                                [searchEnabled]="true"
                                [disabled]="cellInfo.data.disableSubCategory"
                                [dataSource]="cellInfo.data.subCategorySource"
                                [(value)]="cellInfo.data.subCategoryCode"
                                (onValueChanged)="onSubcateogryChanged($event, cellInfo)"
                            ></dx-select-box>
                        </div>

                        <div *dxTemplate="let item of 'itemNumber'">
                            <span>
                                {{ item.row.rowIndex + 1 }}
                            </span>
                        </div>

                        <div *dxTemplate="let cellInfo of 'accountEditCellTemplate'">
                            <app-account-selector
                                [accountTypeSource]="accountTypeSource"
                                [glAccountLabelSource]="glAccountLabelSource"
                                [glAccounts]="glAccountNumberSource"
                                [defaultOffsetGLAccountNumber]="getDefaultOffsetGLAccountNumber()"
                                [disableOffsetGLAccount]="isOffsetGLAccountDisabled()"
                                [selectedAccountType]="cellInfo.data.accountType"
                                [selectedAccountLabel]="cellInfo.data.accountLabelCode"
                                [selectedGLAccountNumber]="cellInfo.data.glAccountNumber"
                                [selectedOffsetAccount]="cellInfo.data.offsetGLAccountNumber"
                                [value]="cellInfo.value"
                                [cellInfo]="cellInfo"
                                (onSelection)="onAccountSelection($event, cellInfo)"
                            ></app-account-selector>
                        </div>
                    </dx-data-grid>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <dx-toolbar width="100%">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Cancel"
                                [icon]="iconCancel"
                                (onClick)="onHidden()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                text="Save"
                                [icon]="iconSave"
                                (onClick)="onSaveClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#arAdjustmentEditorPopup' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<app-transaction-history
    *ngIf="displayTransactionLogPopUp"
    [title]="transactionLogTitle"
    [transactionLogResultData]="transactionLogResultData"
    [communityId]="communityId"
    (onTransactionLogClose)="displayTransactionLogPopUp = false"
></app-transaction-history>

<app-ar-manual-credit-application
    *ngIf="showManualCreditApplication"
    [visible]="showManualCreditApplication"
    [transactionType]="transactionType"
    [transactionId]="arAdjustmentParam.adjustmentId"
    [communityId]="arAdjustmentParam.communityId"
    [managementCompanyId]="arAdjustmentParam.managementCompanyId"
    (onManualCAEditorClose)="onManualCAEditorClose($event)"
></app-ar-manual-credit-application>

<cc-message-box #arAdjustmentMessageBox></cc-message-box>
